
import PropTypes from 'prop-types';
import {useContext} from 'react';
import {useNavigate} from 'react-router-dom';

import {DesignedHeader} from '../../../commonComponents/DesignedHeader';
import {FilterContext} from '../../../context/FilterContext/FilterContext';

const SilverCollection = ({data}) => {
  const {items} = data;

  const navigate = useNavigate();

  const {setFilters} = useContext(FilterContext);

  const handleSilverClick = () => {
    setFilters(prev => ({
      ...prev,
      jewelryType: 'Silver',
    }));

    navigate('/product');
  };

  return (
    <div className={'relative w-full flex flex-col justify-center items-center lg:px-10 p-4'} data-aos={'fade-up'}>
      <div className={'relative flex flex-col justify-center items-center lg:px-20 w-full'}>
        <div className={'text-center text-primary-900 '} data-aos={'fade-up'}>
          <DesignedHeader title={data.title} description={data.description} />
        </div>
        <div
          role={'button'}
          tabIndex={0}
          onClick={handleSilverClick}
          onKeyDown={e => e.key === 'Enter' && handleSilverClick()}
          className={'...'}
        >
          <div className={'grid lg:grid-cols-3 grid-cols-2 lg:gap-4 gap-2 lg:max-w-6xl w-full mx-auto'}>
            {items[0] &&  (
              <div className={'col-span-1 lg:h-52 h-32 flex items-center justify-center rounded-xl'} data-aos={'fade-up'}>
                <img alt={items[0].name} src={items[0].silverImage} className={'w-full h-full object-cover rounded-xl'} />
              </div>
            )}
            {items[1] && (
              <div className={'col-span-1 lg:h-52 h-32 flex items-center justify-center rounded-xl'} data-aos={'fade-up'}>
                <img alt={items[1].name} src={items[1].silverImage} className={'w-full h-full object-cover rounded-xl'} />
              </div>
            )}
            {items[2] && (
              <div className={'col-span-1 lg:row-span-2 lg:h-full h-32 flex items-center justify-center rounded-xl'} data-aos={'fade-up'}>
                <img alt={items[2].name} src={items[2].silverImage} className={'w-full h-full object-cover rounded-xl'} />
              </div>
            )}
            {items[3] && (
              <div className={'lg:col-span-2 col-span-1 lg:h-72 flex h-32 items-center justify-center rounded-xl'} data-aos={'fade-up'}>
                <img alt={items[3].name} src={items[3].silverImage} className={'w-full h-full object-cover rounded-xl'} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

SilverCollection.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        name:PropTypes.string.isRequired,
        silverImage: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default SilverCollection;
